<div class="image-editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config    [device]="device"   [elementChoosing]="objectChoosing" [width]="class['image']['width']" [height]="class['image']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <!-- Số thứ tự của hình ảnh muốn hiển thị  -->
    <div class="d-flex justify-content-between align-items-center" nz-tooltip nzTooltipPlacement="left"
    [nzTooltipTitle]="'neu_so_thu_tu_cua_hinh_anh_muon_hien_thi_khong_co_thi_mac_dinh_se_lay_hinh_anh_dau_tien_de_hien_thi' | translate">
      <p class="mb-0 my-2" style="width: 50%;">{{'so_thu_tu_cua_hinh_anh_muon_hien_thi' | translate}}</p>
      <nz-input-number [nzMin]="1" [nzStep]="1" [ngModel]="config.selected_image_index"
        (nzBlur)="updateConfig()" (ngModelChange)="config.selected_image_index = $event">
      </nz-input-number>
    </div>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <div class="field-row" style="margin: 0">
        <div class="field-row-sub field-row__switch" style="padding: 0" nz-tooltip
        [nzTooltipTitle]="'*_giai_thich_anh_lcp' | translate">
          <span> {{'uu_tien_tai_truoc' | translate}} </span>
          <nz-switch [(ngModel)]="config.is_top_page" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
      </div>

      <!-- Cấu hình object-fit -->
      <li nz-submenu nzTitle="{{'do_bao_phu'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <app-object-fit-config  [device]="device" [class]="class" [objectFitClass]="class['image__boundary--img']"
          [style_field]="style_fields[2]" (isViewAll)="openViewAll($event)" [objectChoosing]="objectChoosing">
        </app-object-fit-config>
      </li>

      <!-- Cấu hình filter -->
      <li nz-submenu nzTitle="{{'anh_sang_va_tuong_phan'| translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <app-brightness-contrast-config [elementChoosing]="objectChoosing"  [device]="device" [class]="class" [config]="config"
          [filterConfig]="config['filter']" [opacityClass]="class['image__boundary--img']" [staticdata]="staticdata"
          [id_object]="objectChoosing._id">
        </app-brightness-contrast-config>
      </li>
      <!-- Cấu hình lật ảnh -->
      <li nz-submenu nzTitle="{{'lat_hinh'| translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="editor-field-body">
          <div class="mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{ 'ngang' | translate }}</p>
                </span>
                <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{ 'doc' | translate }}</p>
                </button>
              </div>
            </div>
          </div>
          <div class="field-row mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('-z')">
                  <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                  <p class="m-0">{{ 'trai' | translate }}</p>
                </button>
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('z')">
                  <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                  <p class="m-0">{{ 'phai' | translate }}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="view">
          <p class="discover_text" (click)="openViewAll(style_fields[6])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-borders-config  [elementChoosing]="objectChoosing"  [device]="device" [class]="class" [borderClass]="class['image__boundary--img']"
          [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->

        <div class="item-border my-3 cursor-pointer" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(style_fields[3])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>
      <!-- Tạo bóng -->
      <li nz-submenu nzTitle="{{'do_bong'| translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <!-- Cấu hình bóng -->
        <div class="editor-field-body">
          <div class="field-row">
            <div class="field-row-sub field-row__switch">
              <span> {{'ap_dung' | translate}} </span>
              <nz-switch [(ngModel)]="config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-switch>
            </div>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0">{{'ngang' | translate}}</p>
              <nz-input-number [(ngModel)]="config['box-shadow'].box_shadow_x" [nzMin]="0" [nzStep]="1"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_x" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0">{{'doc' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_y"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_y" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0 title">{{'kich_thuoc_bong' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_width"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_width" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0 title">{{'do_nhoe' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_blur"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_blur" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="0" [nzMax]="100" [nzStep]="1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item w-100">
              <p class="m-0 w-50">{{'mau_sac' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="config['box-shadow'].box_shadow_color"
                [style.background]="config['box-shadow'].box_shadow_color" (colorPickerClose)="handleSetShadow()"
                [cpWidth]="'230px'" [disabled]="!config.check_shadow" />
            </div>
          </div>
        </div>

      </li>
      <!-- Xem toàn màn hình -->
      <li *ngIf="(!staticdata?.type_link || staticdata.type_link == 'none')" nz-submenu nzTitle="{{'xem_toan_man_hinh'| translate}}"
      [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <!-- Bật tắt chức năng cấu hình toàn màn hình -->
        <div class="field-row" nz-tooltip [nzTooltipTitle]="'khi_click_hinh_anh_se_phong_to_ra_toan_man_hinh' | translate">
          <span class="mx-2 w-50">{{'toan_man_hinh' | translate}}</span>
          <nz-switch [ngModel]="config['image-fullscreen']?.['toggle_fullscreen']"
          (ngModelChange)="config['image-fullscreen']['toggle_fullscreen'] = $event;updateConfig()"
          class="mx-2">
          </nz-switch>
        </div>

        <ng-container *ngIf="config['image-fullscreen']?.['toggle_fullscreen']">
          <!-- Bật tắt mở preview toàn màn hình ở design để cấu hình -->
          <div class="item-border my-3 cursor-pointer" style="float: right">
            <p class="m-0 title-border" (click)="handleOpenFullscreenPreview()">
              {{ 'xem_truoc' | translate }} &#8594;
            </p>
          </div>
        </ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung'| translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config  [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['image']" [effect_hover]="effect_hover" [customize]="customize" 
          [effectFileUsing]="'image'">
        </app-choose-animations-config>
      </li>
      <!-- Thêm liên kết -->
      <li  nz-submenu nzTitle="{{'lien_ket'| translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-link-page-config
          [objectChoosing]="objectChoosing" 
          [staticdata]="staticdata"
          [id_object]="objectChoosing._id"
          [dynamic_data]="objectChoosing.dynamic_data"
          [hasContact]="true"
          [blocks_of_page]="blocks_of_page"
        >
        </app-link-page-config>
      </li>
      <!-- CHỌN THÔNG SỐ -->
      <li nz-submenu nzTitle="{{'chon_thong_so' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
          <mat-form-field style="width: 100%">
            <mat-label>{{'thong_so_san_pham' | translate}}</mat-label>
            <mat-select [(ngModel)]="staticdata.field_custom" (ngModelChange)="onChangeFieldCustom($event)"
              [disabled]="newFields.length == 0">
              <mat-option *ngFor="let item of newFields" [value]="item.field_custom">{{item?.field_lable ??
                item.field_custom}}</mat-option>
            </mat-select>
          </mat-form-field>
          <p class="line-normal" style="color: rgb(212, 78, 78);">
            {{
              'vui_long_vao_trang_admin_truong_du_lieu_tu_tao_tao_du_lieu_sau_do_quay_lai_day_chon_truong_du_lieu' | translate
            }}
          </p>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
      </li>
    </ul>

    <!-- <div *ngIf="loading" style="position: absolute; left:0; top: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.1); display: flex; justify-content: center; align-items: center">

    </div> -->
  </div>
  <!-- Mở rộng -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['image__boundary--img']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 6">
      <app-animations-config [elementChoosing]="objectChoosing"  [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- Mở rộng hình dạng ảnh-->
    <div class="editor-field-body p-0 mt-2" *ngIf="currentViewAll.index == 7">
      <div class="editor-field-body">
        <div class="field-row">
          <!-- <div class="d-flex justify-content-between mt-2 align-items-start">
            <p class="font-weight-bold">Hiển thị trục đối tượng</p>
            <nz-switch [(ngModel)]="config.image.show_axis" (ngModelChange)="updateConfig()"></nz-switch>
          </div> -->
          <p style="font-weight: 500; font-size: 16px">{{'lat_hinh'| translate}}</p>
          <div class="field-row-sub">
            <div style="display: flex; gap: 4px; width: 100%">
              <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')" class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'ngang'| translate}}</p>
              </span>
              <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'doc'| translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item mt-2" style="min-height: 32px">
            <p class="m-0">{{'ngang'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateClassAndConfig()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateY"
            (nzOnAfterChange)="updateClassAndConfig()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateClassAndConfig()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateX"
            (nzOnAfterChange)="updateClassAndConfig()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Xoay hình ảnh -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div style="justify-content: space-between; align-items: center">
            <p class="mt-1" style="font-weight: 500; font-size: 16px">
              {{'xoay_hinh'| translate}}
            </p>
            <div style="display: flex; justify-content: space-between; gap: 4px">
              <button class="btn_transform" nz-button nzType="primary" nzSize="default"
                (click)="handleSetTransform('-z')">
                <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                <p class="m-0">{{'trai'| translate}}</p>
              </button>
              <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                (click)="handleSetTransform('z')">
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                <p class="m-0">{{'phai'| translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item" styl="min-height: 32px">
            <p class="m-0">{{'xoay'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateZ"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateClassAndConfig()"
              >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateZ"
            (nzOnAfterChange)="updateClassAndConfig()"
            (ngModelChange)="SetTransform()">
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Cấu hình Độ nghiêng -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div class="item">
            <p class="m-0" style="font-weight: 500; font-size: 16px">
              {{'do_nghieng'| translate}}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'ngang'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateClassAndConfig()"
              >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewY"
            (nzOnAfterChange)="updateClassAndConfig()"
            (ngModelChange)="SetTransform()"
            >
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateClassAndConfig()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewX"
            (nzOnAfterChange)="updateClassAndConfig()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
      </div>
    </div>
    <!-- Mở rộng cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 3">
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'vi_tri_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'ngang'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_x" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'doc'| translate}}</p>
          <nz-input-number [(ngModel)]="config.image.object_y" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionImage()"></nz-input-number>
        </div>
      </div>
      <div class="field-row mt-2">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'phong_thu_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'do_co_gian'| translate}}</p>
        </div>
        <nz-slider [(ngModel)]="class['image__boundary--img'].transfrom_scale" (nzOnAfterChange)="scale()"
          (ngModelChange)="(class['image__boundary--img'].transfrom_scale)" [nzMin]="0.1" [nzMax]="2"
          [nzStep]="0.1"></nz-slider>
      </div>
    </div>
  </div>
</div>
